import { ArchiveMutation } from "../hooks/useArchiveState";
import { UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinvas Mandhare
 */
export const useUserArchive = () =>
  useMutationWithLoading(async (params: ArchiveMutation) =>
    new UserControllerApi(getConfigObject()).updateUserArchiveStatus(
      params?.id,
      params?.status,
      params?.xTENANTID
    )
  );
